import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: () =>
            import(
            /* webpackChunkName: "home" */ "../views/Home.vue"
            )
    },
    {
        path: "/about",
        name: "about",
        component: () =>
            import(
            /* webpackChunkName: "home" */ "../views/About.vue"
            )
    },
    {
        path: '/login',
        component: () =>
                    import(
                    /* webpackChunkName: "home" */ "../views/register/Index.vue"
                    ),
        children: [
            {
                path: "",
                name: "login",
                component: () =>
                    import(
                    /* webpackChunkName: "home" */ "../views/register/Login.vue"
                    )
            },
            {
                path: "/cadastro",
                name: "cadastro",
                component: () =>
                    import(
                    /* webpackChunkName: "home" */ "../views/register/Signup.vue"
                    )
            },
        ]
    },
    //navegacao principal
    {
        path: "/home",
        component: Index,
        children: [
            {
                path: '',
                name: "categories",
                component: () =>
                    import(
                    /* webpackChunkName: "home" */ "../views/Categories.vue"
                    )
            },
            {
                path: "/contact",
                name: "contact",
                component: () =>
                    import(
                    /* webpackChunkName: "home" */ "../views/Contact.vue"
                    )
            },
            // provas
            {
                path: '/provas',
                component: () =>import(/* webpackChunkName: "modules" */ "../modules/Provas/Index.vue"),
                name: 'provas'
            },
            {
                path: "/modulos",
                component: () =>
                    import(
                    /* webpackChunkName: "modules" */ "../views/Modules.vue"
                    ),
                children: [
                    {
                        path: '',
                        name: "modulos",
                        component: () =>import(/* webpackChunkName: "modules" */ "../modules/Index.vue"),
                    },
                    //rim normal
                    { 
                        path: '/rim-normal',
                        component: () =>
                            import(/* webpackChunkName: "rim-normal" */ "../modules/module01/Index.vue"),
                        children: [
                            {
                                path: '',
                                name: 'rim-normal',
                                component: () =>
                                    import(/* webpackChunkName: "rim-normal" */ "../modules/module01/Modulo01.vue"),
                            },
                            {
                                path: 'intro',
                                component: () =>
                                    import(/* webpackChunkName: "rim-normal" */ "../modules/module01/Intro.vue")
                            }, 
                            {
                                path: 'revisao',
                                component: () =>
                                    import(/* webpackChunkName: "rim-normal" */ "../modules/module01/Revisao.vue")
                            },
                            {
                                path: 'exame',
                                component: () =>
                                    import(/* webpackChunkName: "rim-normal" */ "../modules/module01/Exame.vue")
                            }
                        ]
                    },
                    //nefrite lupica
                    { 
                        path: '/nefrite-lupica',
                        component: () =>
                            import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Index.vue"),
                        children: [
                            {
                                path: '',
                                name: 'nefrite-lupica',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Modulo02.vue"),
                            },
                            {
                                path: 'capitulo-01',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Capitulo01.vue")
                            }, 
                            {
                                path: 'capitulo-02',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Capitulo02.vue")
                            },
                            {
                                path: 'capitulo-03',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Capitulo03.vue")
                            },
                            {
                                path: 'capitulo-04',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Capitulo04.vue")
                            },
                            {
                                path: 'capitulo-05',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Capitulo05.vue")
                            },
                            {
                                path: 'exame',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Exame.vue")
                            },
                            {
                                path: 'bibliografia',
                                component: () =>
                                    import(/* webpackChunkName: "nefrite-lupica" */ "../modules/module02/Bibliografia.vue")
                            }
                        ]
                    }
                ]
            },
            {
                path: "/dashboard",
                name: "dashboard",
                component: () =>
                    import(
                    /* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"
                    )
            }
        ]
    },
    
    
];

const router = new VueRouter({
  routes,
  mode:"history"
});

export default router;
